module.exports = __webpack_public_path__ + "static/media/susalabs_logo.a1a17b41.png";